import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false,
    items: [
      {
        text: 'Об организации',
        href: '/about.html'
      },
      {
        text: 'Наши подопечные',
        href: '/childrens.html'
      },
      {
        text: 'Наш центр',
        href: '/center.html'
      },
      {
        text: 'Как помочь',
        href: '/help.html'
      },
      {
        text: 'Мы в VK',
        href: '/vk.html'
      }
    ]
  },
  getters: {
    links: (state, getters) => {
      return state.items
    }
  },
  mutations: {
    setDrawer: (state, payload) => (state.drawer = payload),
    toggleDrawer: state => (state.drawer = !state.drawer)
  }
})
